/**
 * MEDICLOUD REST API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export const AssessmentStatus = {
    DRAFT: 'DRAFT',
    ORDER: 'ORDER',
    FINISHED: 'FINISHED',
    CONFIRMED: 'CONFIRMED',
    CANCELLED: 'CANCELLED'
} as const;
export type AssessmentStatus = typeof AssessmentStatus[keyof typeof AssessmentStatus];

